<template>
  <v-card class="mx-auto contact-border" max-width="90%">
    <v-row class="contact">
      <v-col>
        <div class="title">
          <span class="large_text">{{ properties.title }}</span>
        </div>
        <div class v-if="properties.text != null">
          <template v-for="(txt, id) in properties.text">
            <CText
              :key="id"
              :text="txt"
              :text_type="text_type"
              :color_text="text_color"
            />
          </template>
        </div>
      </v-col>
      <v-col class="col paragraph">
        <p class="formtext">Votre nom</p>
        <v-text-field
          v-model="form.name"
          label="Votre nom"
          outlined
          dense
        ></v-text-field>
        <p class="formtext">Entreprise, société</p>
        <v-text-field
          v-model="form.enterprise"
          label="Votre organisme"
          outlined
          dense
        ></v-text-field>
        <p class="formtext">Email</p>
        <v-text-field
          v-model="form.mail"
          label="Email"
          outlined
          dense
        ></v-text-field>
        <p class="formtext">Votre message</p>
        <v-textarea
          v-model="form.message"
          label="Votre message"
          outlined
          full-width
          auto-grow
        ></v-textarea>
        <vue-recaptcha
          id="recaptcha"
          :loadRecaptchaScript="true"
          ref="recaptcha"
          @verify="onVerify"
          sitekey="6Lcp4fwUAAAAACI5AQPCtazY19dZtGhnc2XcVMhv"
        ></vue-recaptcha>
        <button outlined @click="sendMail" class="formbutton mt-4">
          <small>Envoyer votre message</small>
        </button>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="sheet.display">
      <v-sheet class="text-center" height="200px">
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet.display = !sheet.display"
          >Continuer</v-btn
        >
        <div class="py-3">{{ sheet.text }}</div>
      </v-sheet>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
const fetch = require("node-fetch");
const validator = require("email-validator");

export default {
  components: { VueRecaptcha },
  name: "OneCol",
  props: {
    index: {
      type: Number,
      default: 0
    },
    properties: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    text_color: "grey_7",
    text_type: "small_text",
    isSending: false,
    form: {
      name: "",
      mail: "",
      message: "",
      enterprise: ""
    },
    sheet: {
      display: false,
      text: ""
    },
    captcha: {
      id: "",
      verify: false
    }
  }),
  beforeMount() {},
  methods: {
    onVerify: function(response) {
      this.captcha.id = response;
      this.captcha.verify = true;
    },
    resetCaptcha() {
      this.$refs.recaptcha.reset();
      this.captcha.id = "";
      this.captcha.verify = false;
    },
    checkValidity() {
      if (
        this.form.name == "" ||
        this.form.mail == "" ||
        this.form.message == ""
      ) {
        this.sheet.display = true;
        this.sheet.text =
          "L'un des champs est vide. Merci de renseigner toutes les informations.";
        return false;
      }
      if (!validator.validate(this.form.mail)) {
        this.sheet.display = true;
        this.sheet.text =
          "Email invalide, merci de renseigner un email correct.";
        return false;
      }
      if (!this.captcha.verify) {
        this.sheet.display = true;
        this.sheet.text = "Merci de remplir le captcha.";
        return false;
      }
      return true;
    },
    resetForm() {
      this.form = {
        name: "",
        mail: "",
        message: "",
        enterprise: ""
      };
    },
    sendMail() {
      if (!this.checkValidity()) return;
      var body = {
        mail_name: this.form.name,
        mail_email: this.form.mail,
        mail_entreprise: "enterprise ",
        mail_message: this.form.message
      };

      var options = {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" }
      };

      fetch("https://fonciermailer.herokuapp.com", options)
        .then(json => json.text())
        .then(res => JSON.parse(res))
        .then(json => {
          this.sheet.display = true;
          if (json.status == "SUCCESS") {
            this.sheet.text =
              "Merci de nous avoir contacté, notre équipe reviendra vers vous prochainement.";
            this.resetForm();
            this.resetCaptcha();
          } else {
            this.sheet.text =
              "Un problème technique est survenu, nous faisons le nécessaire de notre côté.";
          }
        })
        .catch(() => {
          this.sheet.display = true;
          this.sheet.text =
            "Un problème technique est survenu, nous faisons le nécessaire de notre côté.";
        });
    }
  }
};
</script>

<style scoped>
.contact-border {
  border-radius: 25px !important;
}

.contact {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}

.title {
  padding-bottom: 4%;
}

.contact-box {
  padding-top: 5%;
}

.paragraph {
  margin: 0px;
}

.formtext {
  margin: 0px;
}

.formbutton {
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  position: static;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  background: #e0fcff;
  border: 1px solid #87eaf2;
  box-sizing: border-box;
  border-radius: 4px;
  flex: none;
  order: 0;
  align-self: center;
}
</style>
